exports = module.exports = require("./../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "footer[_v-3a9b89d8]{bottom:0;left:0;width:100%;padding-bottom:10px;padding-top:10px}footer .container[_v-3a9b89d8]{margin-top:15px;margin-bottom:15px}footer p[_v-3a9b89d8]{margin-bottom:0}footer a[_v-3a9b89d8]{display:inline-block;margin-left:5px}@media (max-width:767px){footer.login[_v-3a9b89d8]{font-size:12px}}footer.login[_v-3a9b89d8],footer.login a[_v-3a9b89d8]{color:#fff}footer.login .container[_v-3a9b89d8]{background:transparent}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-rewriter.js?id=_v-3a9b89d8&scoped=true!./~/sass-loader!./~/vue-loader/lib/selector.js?type=style&index=0!./assets/component/base/footer.vue
// module id = 296
// module chunks = 0